export const compare = (
  a: string | undefined,
  b: string | undefined,
): boolean =>
  Boolean(a && a?.toLocaleLowerCase('en-US') === b?.toLocaleLowerCase('en-US'));

export const toCamel = (string: string) => {
  return string.replace(/([-_\s][a-z])/gi, s => {
    return s
      .toLocaleUpperCase('en-US')
      .replace('-', '')
      .replace('_', '')
      .replace(' ', '');
  });
};

export const endsWithInvariantCase = (string: string, endsWith: string) =>
  string
    .toLocaleLowerCase('en-US')
    .endsWith(endsWith.toLocaleLowerCase('en-US'));

export const startsWithInvariantCase = (string: string, startsWith: string) =>
  string
    .toLocaleLowerCase('en-US')
    .startsWith(startsWith.toLocaleLowerCase('en-US'));

export const includesInvariantCase = (
  string: string | string[],
  inclusion: string,
) =>
  typeof string === 'string'
    ? string
        .toLocaleLowerCase('en-US')
        .includes(inclusion.toLocaleLowerCase('en-US'))
    : string.some(s => compare(s, inclusion));

export const replace = (
  text: string,
  values: Record<string, string | undefined>,
) => {
  for (const [variable, value] of Object.entries(values)) {
    const matcher = new RegExp(`\\\${{\\\s?values\\\.${variable}\\\s?}}`, 'g');
    text = text.replace(matcher, value ?? ''); // eslint-disable-line no-param-reassign
  }
  return text;
};

/** Maximum length of a sanitized log fragment. */
const MAX_LOG_VALUE_LENGTH = 200;

/**
 * Sanitize an untrusted value for inclusion in a log message: replace C0/DEL
 * control characters (which could forge or corrupt a log entry) with spaces and
 * cap the length. For display only — never use the result to construct a ref.
 * Log-injection defense for any untrusted string written to logs.
 */
export const sanitizeForLog = (value: string): string => {
  let out = '';
  for (const ch of value.slice(0, MAX_LOG_VALUE_LENGTH)) {
    const code = ch.charCodeAt(0);
    out += code < 0x20 || code === 0x7f ? ' ' : ch;
  }
  return out;
};
